import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "../../views/chart/chart.component";
import {ModalService} from "../../views/modal/base_modal.component";
import { SitesService } from "../../sites/sites.service";
import { ICharts } from "../../models/responce_result.model";

interface ICategoryDynamicCharts extends ICharts {
	categoriesMap: string[];
	fields: string[];
}

@Component({
	selector: 'category-dynamics',
	templateUrl: './category_dynamics.component.html'
})
export class CategoryDynamicsComponent extends BaseComponent {
	addFilterParams = {
		userType: 'user',
		dateFilters : ['dateCreated', 'dateSiteCreated', 'datePaid'],
		period: 'month'
	};

	chart = new ChartParams();
	
	chartLoader: boolean = false;

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public modalService: ModalService,
		public http: HttpClient,
		public helper: HelperService,
		public siteService: SitesService,
		
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);
	}

	async getData() {
		await this.getChart();
	}
	
	
	async getChart() {
		this.chartLoader = true;
		
		const { charts, categoriesMap, fields, } = await this.siteService.categoryDynamics.chart<ICategoryDynamicCharts>(
			this.filter.filterParams,
		).toPromise();
		
		this.chart.setOptions({
			names: categoriesMap,
			showLabels: fields
		});
		
		this.chart.data = charts;

		this.chartLoader = false;
	}
}
